import { MainLogo } from "@ui/Logos/MainLogo";
import { Paragraph } from "@ui/Content";
import { Button } from "@ui/Button";
import { H3 } from "@ui/Headings";
import { OUTLOOK_ADDIN_URL } from "@config/constants";
import { BackgroundSection } from "@components/Sections";
import OutlookIcon from "@assets/icons/outlook.svg";

export default function GetOutlookAddinScreen() {
  const handleInstallAddin = () => {
    window.open(OUTLOOK_ADDIN_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center pt-[100px] pb-[30px]">
        <MainLogo className="pb-[50px]" />

        <BackgroundSection
          className="bg-white"
          icon={
            <OutlookIcon
              width={16}
              height={16}
              className={"stroke-[1.76]"}
            />
          }
        />
        <div className="flex flex-col justify-center items-center gap-2 px-4 pt-6">
          <H3 className="text-[#406A68] font-bold my-3">
            Use the Meridian Add-in for Outlook
          </H3>

          <Paragraph className="text-center pb-3">
            To work with emails and meetings in Outlook, install the Outlook Add-in.
          </Paragraph>

          <Button buttonType={"PRIMARY"} onClick={handleInstallAddin} className="min-w-[270px]">
            Get Outlook Add-in
          </Button>
        </div>
      </div>
    </div>
  );
}
